import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	thisServiceProject: {
		id: 'servicedesk-sla-settings.reusable-calendars.this-service-project',
		defaultMessage: 'This service project',
		description: 'Title of the tab that shows calendars of the current project',
	},
	otherCalendarsTabTitle: {
		id: 'servicedesk-sla-settings.reusable-calendars.other-calendars-tab-title',
		defaultMessage: 'Other calendars',
		description: 'Title of the tab that shows calendars of other projects',
	},
	otherCalendarsTabTooltip: {
		id: 'servicedesk-sla-settings.reusable-calendars.other-calendars-tab-tooltip',
		defaultMessage: 'Save time by copying calendars from other service projects',
		description: 'Title of the tab that shows calendars of other projects',
	},
});
